var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.configs
    ? _c(
        "w-list",
        [
          _c(
            "w-list-item",
            [
              _c("w-list-item-text", [
                _c("b", [_vm._v(_vm._s(_vm.$ct("view")))]),
              ]),
              _vm.$wf.isMdUp
                ? _c("w-list-item-text", [
                    _c("b", [_vm._v(_vm._s(_vm.$ct("id-first")))]),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._l(_vm.filteredConfig, function (key, i) {
            return _c(
              "w-list-item",
              {
                key: i,
                attrs: { disabled: _vm.getKeyDisabledMessage(key) != "" },
                on: {
                  click: function ($event) {
                    return _vm.edit(key)
                  },
                },
              },
              [
                _c("w-list-item-text", [
                  _vm._v(
                    _vm._s(_vm.translateKey(key)) +
                      " " +
                      _vm._s(_vm.getKeyDisabledMessage(key))
                  ),
                ]),
                _vm.$wf.isMdUp
                  ? _c("w-list-item-text", [
                      _vm._v(
                        _vm._s(_vm.getFirstNumberExample(_vm.configs[key]))
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            )
          }),
          _vm._l(_vm.saleTypes, function (type) {
            return _c(
              "w-list-item",
              {
                key: `sale-${type.ID}`,
                attrs: {
                  disabled: _vm.getSaleKeyDisabledMessage(type) != "",
                  error: _vm.hasSaleTypeError(type),
                },
                on: {
                  click: function ($event) {
                    return _vm.editSaleType(type)
                  },
                },
              },
              [
                _c("w-list-item-text", [
                  _vm._v(
                    _vm._s(_vm.translateSaleTypeKey(type)) +
                      " " +
                      _vm._s(_vm.getSaleKeyDisabledMessage(type))
                  ),
                ]),
                _vm.$wf.isMdUp
                  ? _c("w-list-item-text", [
                      _vm._v(
                        _vm._s(
                          _vm.getFirstNumberExample(
                            _vm.configs.SaleConfigs[`${type.ID}`]
                          )
                        )
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            )
          }),
          _c(
            "w-modal",
            {
              model: {
                value: _vm.editModal,
                callback: function ($$v) {
                  _vm.editModal = $$v
                },
                expression: "editModal",
              },
            },
            [
              _vm.editedItem
                ? _c(
                    "w-card",
                    { attrs: { "max-width": "500" } },
                    [
                      _c("w-card-title", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$ct("id-edit-title", {
                                type: _vm.translatedKey,
                              })
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "w-card-content",
                        [
                          _c("app-friendly-id-edit", {
                            attrs: { bookyear: _vm.bookyear },
                            model: {
                              value: _vm.editedItem,
                              callback: function ($$v) {
                                _vm.editedItem = $$v
                              },
                              expression: "editedItem",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-card-actions",
                        [
                          _c(
                            "w-button",
                            {
                              staticClass: "cancel",
                              attrs: { icon: "ban" },
                              on: {
                                click: function ($event) {
                                  return _vm.cancel()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("common.cancel")) + " "
                              ),
                            ]
                          ),
                          _c("w-spacer"),
                          _c(
                            "w-button",
                            {
                              attrs: { icon: "save" },
                              on: {
                                click: function ($event) {
                                  return _vm.save()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }